import _ from 'lodash';
import QqConstants from 'sg-qq-constants';

const isLegalReferrer = () => {
    if (!document.referrer) {
        return false;
    }
    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
        return _.includes(QqConstants.WHIITELISTED_REFERRERS.LOCAL, document.referrer);
    }
    return _.some(QqConstants.WHIITELISTED_REFERRERS.NON_LOCAL, (element) => element.includes(document.referrer));
};

export default {
    isLegalReferrer
};
